import { createSlice } from "@reduxjs/toolkit";

interface AuthState {
  login: string | null;
  role: string | null;
  token: string | null;
  refreshToken: string | null;
}

const initialState: AuthState = {
  login: null,
  role: null,
  token: null,
  refreshToken: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.login = payload.login;
      state.role = payload.role;
      state.token = payload.token;
      state.refreshToken = payload.refreshToken;
    },

    removeUser: (state) => {
      state.login = null;
      state.role = null;
      state.token = null;
      state.refreshToken = null;
    },
  },
});

export const { setUser, removeUser } = authSlice.actions;
export default authSlice.reducer;
